// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1XJn_","footer":"ModalInfo_footer__1Whbj"};